import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Watch, Prop, InjectReactive } from "vue-property-decorator";
import ModulesSet from "./ModulesSet.vue";
import ModulesPreview from "./ModulesPreview.vue";
import ModulesConfig from "./ModulesConfig.vue";
import manualAddCpn from "../questionBank/manualAddNew.vue";
import { mixins } from "vue-class-component";
import commonMixin from "@/mixins/commonNewMixins";
import { questionData, questionDataForReviews, questionDataForQAE, testData, literatureData } from "../../../../config/newQuestionnaire";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
import surveyTemplateSelectDialog from "./surveyTemplateSelectDialog.vue";
import DeduplicationClassDialog from "./deduplicationClassDialog.vue";
let questionnaireSet = class questionnaireSet extends mixins(commonMixin) {
  constructor() {
    super(...arguments);
    this.cmpsData = []; // $ 基础组件
    this.dialogVisibleManualAddCpn = false;
    this.deduplicationClassDialogVisible = false;
    this.deduplicationClassMode = "SET";
    ////////////////////////
    //选择问卷模板
    this.surveyTemplateSelectDialogVisible = false;
    //////////////////////
    this.configMode = "all";
  }
  listenQuestionnaireType(newval) {
    // this.getData();
    console.log("questionnaireType", newval, this.surveyType);
    if (this.surveyType === "LITERATURE") {
      // 补充提交文献信息 问卷
      this.cmpsData = literatureData;
      return;
    }
    if (newval == "QUESTIONNAIRE") {
      if (this.activityQuestionnaireProperty == "REVIEWS") {
        this.cmpsData = JSON.parse(JSON.stringify(questionDataForReviews));
      } else if (this.activityQuestionnaireProperty == "DOCTOR_QUESTION" || this.activityQuestionnaireProperty == "EXPERT_ANSWER") {
        this.cmpsData = JSON.parse(JSON.stringify(questionDataForQAE));
      } else {
        this.cmpsData = JSON.parse(JSON.stringify(questionData));
      }
      // 预约组件目前仅针对报名前置收集 开放配置
      if (this.activityQuestionnaireProperty == "INFORMATION_COLLECTION") {
        const advanceArray = this.cmpsData.filter(item => {
          return item.key === "advanceArray";
        })[0].questionItem;
        const componentNames = advanceArray.map(item => item.componentName);
        // console.log("questionnaireType", componentNames);
        if (componentNames.includes(30)) {
          advanceArray.splice(componentNames.indexOf(30), 1);
        }
      }
      if (this.activityQuestionnaireProperty == "INFORMATION_COLLECTION") {
        const advanceArray = this.cmpsData.filter(item => {
          return item.key === "advanceArray";
        })[0].questionItem;
        const componentNames = advanceArray.map(item => item.componentName);
        // console.log("questionnaireType", componentNames);
        if (componentNames.includes(30)) {
          advanceArray.splice(componentNames.indexOf(30), 1);
        }
      }
    } else {
      this.cmpsData = testData;
    }
  }
  get answerItemList() {
    return this.dataList.filter(item => {
      return [1, 2].includes(item.componentName);
    });
  }
  get isConfigforAllShow() {
    return QuestionnaireEditModule.isConfigforAllShow;
  }
  get isModel() {
    return QuestionnaireEditModule.isModel;
  }
  get isAnswerMode() {
    return this.questionnaireType == "ANSWER";
  }
  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }
  get dataList() {
    return QuestionnaireEditModule.dataList;
  }
  get showBank() {
    if (this.activityQuestionnaireProperty) {
      return !["HEALTH_SERVICE_PROJECT"].includes(this.activityQuestionnaireProperty);
    } else {
      return false;
    }
  }
  // 问卷排重
  get participateRepeatedCheck() {
    return QuestionnaireEditModule.basicData.participateRepeatedCheck;
  }
  get participateRepeatedClassId() {
    return QuestionnaireEditModule.basicData.participateRepeatedClassId;
  }
  get participateRepeatedClassName() {
    return QuestionnaireEditModule.basicData.participateRepeatedClassName;
  }
  isRepeatedChange(val) {
    QuestionnaireEditModule.SET_BASIC_DATA_REPEATED(val);
    if (!val) {
      QuestionnaireEditModule.SET_BASIC_DATA_REPEATEDCLASSID("");
      QuestionnaireEditModule.SET_BASIC_DATA_REPEATEDCLASSNAME("");
    }
  }
  opendeDuplicationClassDialog(mode) {
    this.deduplicationClassDialogVisible = true;
    this.deduplicationClassMode = mode;
  }
  settingClassChange(item) {
    QuestionnaireEditModule.SET_BASIC_DATA_REPEATEDCLASSNAME(item.settingName);
    QuestionnaireEditModule.SET_BASIC_DATA_REPEATEDCLASSID(item.id);
  }
  /////////////////////
  mounted() {
    // this.cmpsData = questionData;
  }
  surveyTemplateSelectSuccess(questionnaireId) {
    console.log("surveyTemplateSelectSuccess", questionnaireId);
    this.$emit("refreshQuestionnaireId", questionnaireId);
  }
  configModeChange(mode) {
    this.configMode == mode;
  }
  getModulesConfigInstance() {
    return this.$refs.modulesConfig;
  }
  async CHECK_DATA_validate() {
    try {
      let result = await this.getModulesConfigInstance().validate();
      if (result.valid) {
        let totalScore = 0;
        this.dataList.forEach(element => {
          totalScore += Number(element.data.itemScore) || 0;
        });
        QuestionnaireEditModule.SET_TOTALSCORE_DATA(totalScore);
      }
      const logicResult = await this.getModulesConfigInstance().validatLogicSetData();
      if (!logicResult) {
        this.$message.warning("请检查规则设置");
        // this.$notify.error({
        //   title: "规则设置",
        //   message: "请检查规则设置",
        // });
      }
      let auditLogicResult = true;
      if (QuestionnaireEditModule.showVerifactionConfig) {
        auditLogicResult = await this.getModulesConfigInstance().validatAuditLogicSetData();
        if (!auditLogicResult) {
          this.$message.warning("请检查审核设置");
          // this.$notify.error({
          //   title: "审核设置",
          //   message: "请检查审核设置",
          // });
        }
      }
      // 机审题型配置校验：存在失效（已删除）题目时阻止提交
      const machineAuditTypeResult = await this.getModulesConfigInstance().validatMachineAuditTypeData();
      if (!machineAuditTypeResult) {
        this.$message.warning("请检查机审题型配置");
      }
      const repeatedCheckError = this.participateRepeatedCheck && !this.participateRepeatedClassId;
      if (repeatedCheckError) {
        this.$message.warning("请填写排重设置");
        // this.$notify.error({
        //   title: "排重设置",
        //   message: "请填写排重设置",
        // });
      }
      return result.valid && logicResult && auditLogicResult && machineAuditTypeResult && !repeatedCheckError;
    } catch (error) {
      console.log("CHECK_DATA_validateerror", error);
      return false;
    }
  }
};
__decorate([Prop({
  type: String,
  default: "ACTIVITY"
})], questionnaireSet.prototype, "type", void 0);
__decorate([Prop({
  default: "ACTIVITY_INTERACT"
})], questionnaireSet.prototype, "activityQuestionnaireProperty", void 0);
__decorate([InjectReactive()], questionnaireSet.prototype, "surveyType", void 0);
__decorate([Watch("questionnaireType", {
  deep: true,
  immediate: true
})], questionnaireSet.prototype, "listenQuestionnaireType", null);
questionnaireSet = __decorate([Component({
  name: "questionnaireSet",
  components: {
    ModulesSet,
    ModulesPreview,
    ModulesConfig,
    manualAddCpn,
    surveyTemplateSelectDialog,
    DeduplicationClassDialog
  },
  filters: {}
})], questionnaireSet);
export default questionnaireSet;